import type {FinishedResponseInteractionService, WalkerService} from 'shared/services';
import {Subkind} from 'shared/constants';
import type {Auth, Fond, Rec} from 'src/typings';
import type {RecordClipboardService} from '../../../record/kp-record-clipboard/record-clipboard.service';
import type {Observable} from 'rxjs';
import type {RecordEditationDataService} from '../../../record-editation/services/record-editation.data-service';
import type RecordService from '../../../record/record.service';
import type RecordDataService from '../../../record/record.data-service';

export class KpSearchItemAuthorityPresenter {
    public static presenterName = 'kpSearchItemAuthorityPresenter';

    /*@ngInject*/
    constructor(public currentAuth: Auth,
                private recordDataService: RecordDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService,
                private recordClipboardService: RecordClipboardService,
                private recordEditationDataService: RecordEditationDataService,
                private walker: WalkerService,
                private recordService: RecordService) {
    }

    public async getRelatedRecordsCount(record: Rec): Promise<number> {
        const response = await this.recordDataService.getRelatedRecordsCount(record.id);
        return response.value;
    }

    public getRecordLink(id: string): string {
        return `/#!/records/${id}`
    }

    public async mergeToThis(record: Rec) {
        try {
            await this.recordService.mergeRecordsAndReload(record, this.recordClipboardService.getAll());
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
        }
    }

    public clipboardRecords(): Observable<Rec[]> {
        return this.recordClipboardService.getRecords$();
    }

    public async createRecordEditation(record: Rec, fond: Fond): Promise<void> {
        const recordEditation = await this.recordEditationDataService.createNewEditation({
            record,
            fond,
            subkind: Subkind.SUBKIND_AUTHORITY
        });

        await this.walker.newSpaPage(`/record-editations/${recordEditation.id}`);
    }
}